<template>
  <div>
    <!-- Quote Edit Form -->
    <div id="quote-edit">
      <vendor-rmas-edit-header ref="headerDetails" @header-validation="isValidHeader = !($event)" />
      <section class="quotes--quote-summary">
        <b-card>
          <b-row v-if="checkClaim(CAN_ADD_VENDOR_RETURNS)">
            <b-col>
              <div class="tools first-row">
                <b-button @click="openRmaPartsModal(true)" size="sm" variant="primary" class="mr-2">
                   <i class="fa fa-plus" aria-hidden="true"></i>
                   Add Item
                </b-button>
                <b-button @click="activateCreditMemo" v-if="showActiveMemoBtn" size="sm" variant="primary" class="mr-2" :disabled="selectedCreditMemo == 0 || !vendorrma.isAuthorized">
                  Activate Credit Memo
                </b-button>
                <b-button @click="createPO" v-if="showCreatePOBtn" size="sm" variant="primary" class="mr-2" :disabled="!vendorrma.isAuthorized || isCreatingPO">
                  <i v-if="isCreatingPO" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                  <i v-else class="fa fa-plus" aria-hidden="true"></i>
                  Create Purchase Order
                </b-button>
                <b-button @click="openPickListModal" v-if="showReceiveItemBtn" size="sm" variant="primary" class="mr-2" :disabled="!vendorrma.isAuthorized || selectedPoLineId == 0 || isGettingInventories">
                  <i v-show="isGettingInventories" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                  {{ isGettingInventories ? 'Getting' : '' }} Return Item
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <vendor-rma-lines
              :vendorrmaId="vendorRmaId"
              @showEdit="showEdit"
              @showDelete="showDelete"
              @selectedVendorRmaLine="setVendorRmaLine"
            />
<!--            @selectedVendorRmaLine="vendorRmaLine = $event"-->
          </b-row>
        </b-card>
      </section>
      <b-tabs>
        <b-tab title="Summary">
          <vrma-summary @onRefresh="onRefresh" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_INVENTORY)" >
          <template v-slot:title>
            Inventory &nbsp;<b-badge variant="primary">{{ inventoryListFiltered.length }}</b-badge>
          </template>
          <inventory-list :partId="0" :inventoryId="vendorRmaLine.inventoryId" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_POS)" >
          <template v-slot:title>
            Purchase Orders &nbsp;<b-badge variant="primary">{{ purchaseOrderLines.length }}</b-badge>
          </template>
          <purchase-order-line :purchaseOrderLineId="vendorRmaLine.poLineId" :gridId="purchaseOrderGridId" />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_ALL_POS)" >
          <template v-slot:title>
            Customer RMAs &nbsp;<b-badge variant="primary">{{ rmaLinesByFilter.length }}</b-badge>
          </template>
          <crma-lines :id="vendorRmaLine.rmaLineId" isRmaAsTab />
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_CREDIT_MEMO)" >
          <template v-slot:title>
            Credit Memos &nbsp;<b-badge variant="primary">{{ creditMemoByReference.length }}</b-badge>
          </template>
          <credit-memos ref="cmemo" :vendorRmaId="vendorRmaLine.vendorRMAId" :contactEmail="vendorrma.contactEmail" @selectedCreditMemo="selectedCreditMemo = $event"/>
        </b-tab>
        <b-tab v-if="checkClaim(CAN_VIEW_INVENTORY)">
          <template v-slot:title>
            Pick Tickets <b-badge variant="primary">{{ pickTicketLinesByVendorRMALine.length }}</b-badge>
          </template>
          <pick-ticket-lines-tab :vendorRmaLineId="vendorRmaLine.id" isVRMATab />
        </b-tab>
        <b-tab title="Documents and Images">
           <documents-and-images :reference="'vendorRmaLineId'" :refId="vendorRmaLine.id" :partId="vendorRmaLine.partId" />
        </b-tab>
      </b-tabs>
      <div class="d-flex justify-content-between mt-2">
        <div></div>
        <div class="mr-5">
          <b-button type="button" variant="secondary" size="sm" @click="navigateToList()"
                    v-if="checkClaim(CAN_VIEW_ALL_VENDOR_RETURNS)">Exit</b-button>
          <b-button variant="primary" type="submit" class="ml-2" size="sm" @click="saveVrmaDetails(false)" :disabled="isSaving"
                    v-if="checkClaim(CAN_EDIT_VENDOR_RETURNS)"><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save and Continue</b-button>
          <b-button variant="primary" type="submit" class=" ml-2" size="sm" @click="saveVrmaDetails(true)" :disabled="isSaving"
                    v-if="checkClaim(CAN_EDIT_VENDOR_RETURNS) && checkClaim(CAN_VIEW_ALL_VENDOR_RETURNS)"><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save and Exit</b-button>
          <b-button size="sm" class="ml-2" :variant="vendorrma.isAuthorized ? 'success' : 'danger'" @click="onAuthorize" :disabled="isSaving"
                    v-if="checkClaim(CAN_AUTHORIZE_VENDOR_RETURNS)">
            <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>{{ vendorrma.isAuthorized ? 'Unauthorize' : 'Authorize' }}
          </b-button>
<!--          <b-button variant="primary" size="sm" class="ml-2" v-if="!vendorrma.isAuthorized">Authorize</b-button>-->
          <b-button
            variant="primary"
            size="sm"
            @click="onEmailRMA"
            class="ml-2"
            :disabled="!vendorrma.isAuthorized"
          >
            <i v-show="isEmailLoading" class="fa fa-spinner fa-pulse fa-fw" ></i> Send Email
          </b-button>
          <send-emails :sendEmailData="sendEmailData"></send-emails>
          <!-- <b-button variant="primary" @click="$bvModal.show('view-fast-report')" size="sm" class="ml-2" :disabled="!vendorrma.isAuthorized">Print</b-button> -->
        </div>
      </div>
    </div>

    <!-- RMA Add Part Modal -->
    <vrma-po-line :isAddPart="rmaAddPartAction" :vrmaPoLine="onEditRMAPart" :vrmaId="vendorRmaId" @onRefresh="onRefresh" />

    <!-- PickList Modal -->
    <pick-list-modal
      :pickTicketList="vramInventoryForReturning"
      :modalId="pickListmodalId"
      :poLineId="selectedPoLineId"
      :vendorRMAId="vendorRmaId"
      :vendorRMALineId="selectedvendorRMALineId"
    />

    <!-- <fast-report-viewer :parameter="vendorRmaId" :moduleName="'VendorRMAs'" /> -->
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { GRID_ID, REPORTS_CONSTANTS } from '@/shared/constants';
import RequirementDetails from '@/shared/components/RequirementDetails/index';
import VendorRmaLines from '@/pages/Vendorrmas/components/VendorrmaLines';
//import QuoteHeader from '@/pages/Quotes/components/QuoteHeader';
import VendorRmasEditHeader from './components/header';
import VrmaSummary from '../VrmaSummary';
import Charges from '@/pages/Quotes/components/EditQuote/components/Charges';
import PartForm from '@/shared/components/Parts';
import QuoteLineEdit from '@/shared/components/QuoteLine';
//import Sources from '@/shared/components/Sources';
// import Offers from '@/shared/components/Offers';
import Requirements from '@/shared/components/Requirements';
import InventoryList from '@/shared/components/InventoryList';
import CrmaLines from '@/pages/Customerrmas/components/CustomerrmasLines';
import SendEmails from '@/shared/components/SendEmails/index';
import ItemRequirements from '@/shared/components/ItemRequirements/index';
import ChargesList from '@/shared/components/ChargesList/index';
import PurchaseOrderLine from '@/shared/components/PurchaseOrderLine';
import Calculator from '@/shared/components/Calculator';
import VrmaPoLine from '@/pages/Vendorrmas/components/VrmaPoLine';
import PendingVrmaView from '@/pages/Vendorrmas/components/add/RmaModal';
import DocumentsAndImages from '@/shared/components/DocumentsAndImages';
import FastReportViewer from '@/shared/components/FastReportViewer';

import PickListModal from '@/pages/ShippingReceiving/components/VendorRMAsTab/components/PickList';
import CreditMemos from '@/shared/components/CreditMemos';
import PickTicketLinesTab from '@/shared/components/PickList/components/PickTicketLines';

export default {
  data() {
    return {
      rmaAddPartAction: true,
      onEditRMAPart: {},
      vendorRmaLine: {},
      sendEmailData:{},
      isEmailLoading: false,
      purchaseOrderGridId: GRID_ID.PURCHASE_ORDERS_SERVICE_ORDER_GRID,
      modalId: "rma-poline-modal",
      pickListmodalId: 'vendor-rma-return-pick-list',
      isSaving: false,
      selectedPoLineId: 0,
      selectedvendorRMALineId: 0,
      isGettingInventories: false,
      selectedCreditMemo: 0,
      isCreatingPO: false,
      isValidHeader: false
    };
  },
  metaInfo() {
    return {
      title: this.titleGenerate,
    }
  },
  components: {
    RequirementDetails,
    VendorRmaLines,
    VendorRmasEditHeader,
    VrmaSummary,
    Charges,
    ChargesList,
    Requirements,
    ItemRequirements,
    PartForm,
    QuoteLineEdit,
    Calculator,
    VrmaPoLine,
    PendingVrmaView,
    InventoryList,
    CrmaLines,
    SendEmails,
    DocumentsAndImages,
    PurchaseOrderLine,
    FastReportViewer,
    PickListModal,
    CreditMemos,
    PickTicketLinesTab
  },
  computed: {
    // ...mapGetters('quoteDetails', ['quoteById']),
    ...mapGetters('quotes', ['quote']),
    ...mapGetters('lookup', ['rmaReasons', 'vendorRmaTerms', 'vendorRmaActions']),
    ...mapGetters('vendorrmas', ['vendorrma']),
    ...mapState('invoiceLines', ['invoiceLines']),
    // ...mapGetters('purchaseOrderLines', ['purchaseOrderLines', 'poLineWithInventory']),
    //...mapGetters('companies', ['company']),

    ...mapGetters('shippingReceiving', [
      'vramInventoryForReturning'
    ]),
    
    ...mapGetters('inventory', ['inventoryListFiltered']),
    ...mapGetters('purchaseorders', ['purchaseOrderLines']),
    ...mapGetters('customerRmasLines', ['rmaLinesByFilter']),
    ...mapGetters('creditMemos', ['creditMemoByReference']),
    ...mapGetters('pickTicket', ['pickTicketLinesByVendorRMALine']),

    vendorRmaId() {
      return this.$route.params.id;
    },
    companyId() {
      return this.$route.params.companyId;
    },
    isSaveEnable() {
      return this.validateRequiredFields();
    },
    titleGenerate() {
      return `Vendor RMA: ${this.vendorRmaId} - ${this.vendorrma.companyName}`;
    },
    reportOption() {
      return REPORTS_CONSTANTS.filter(x => x.module == 'VendorRMAs');
    },
    showCreatePOBtn(){
      let selectedvendorRmaTerms  = this.vendorRmaTerms.find(x => x.id == this.vendorrma.termsId)
      let status = false;
      if(selectedvendorRmaTerms != undefined && Object.keys(selectedvendorRmaTerms).length >= 1) {
        if(selectedvendorRmaTerms.name === "Replace"){
          status = true;
        }
      }

      return status;
    },
    showActiveMemoBtn(){
      let selectedvendorRmaTerms  = this.vendorRmaTerms.find(x => x.id == this.vendorrma.termsId)
      let status = false;
      if(selectedvendorRmaTerms != undefined && Object.keys(selectedvendorRmaTerms).length >= 1) {
        if(selectedvendorRmaTerms.name === "Credit" || selectedvendorRmaTerms.name === "Refund"){
          status = true;
        }
      }

      return status;
    },
    showReceiveItemBtn(){
      let selectedvendorRmaActions  = this.vendorRmaActions.find(x => x.id == this.vendorrma.actionId)
      let status = false;
      if(selectedvendorRmaActions != undefined && Object.keys(selectedvendorRmaActions).length >= 1) {
        if(selectedvendorRmaActions.name === "Return"){
          status = true;
        }
      }

      return status;
    }
  },
  methods: {
    ...mapActions('vendorrmas', ['getById', 'onSaveVRMALine', 'onUpdateVRMALine', 'onDeleteVRMALine', 'updateVrma', 'authorizingVRMA', 'createPOByVendrRmaId']),
    ...mapActions('purchaseOrderLines', ['getPurchaseOrderLines' ]),
    ...mapActions('companies', { companyById: 'getById' }),
    ...mapActions('requirementAdd', [
      'getShipViaList',
    ]),

    ...mapActions('shippingReceiving', ['getInventoriesForReturningVrma']),
    ...mapActions('creditMemos', ['manageCreditMemo']),

    openRmaPartsModal(isAddPart) {
      this.rmaAddPartAction = isAddPart;
      this.$bvModal.show(this.modalId);
    },
    showEdit($e) {
      this.onEditRMAPart = $e;
      this.openRmaPartsModal(false);
    },
    async setVendorRmaLine(rmaLine){
      this.vendorRmaLine = { ...rmaLine };
      // console.log('setVendorRmaLine part',this.vendorRmaLine);
      try{
        this.selectedvendorRMALineId = rmaLine.id;
        this.selectedPoLineId = rmaLine.poLineId;
        this.isGettingInventories = true;
        await this.getInventoriesForReturningVrma(rmaLine.poLineId);
        this.isGettingInventories = false;
      } catch (e) {
        /*console.log(e.message);*/
        this.isGettingInventories = false;
      }
    },
    async showDelete() {
      this.onRefresh();
    },
    async saveVrmaDetails(isExit, isAuthorize = false) {
      try {
        this.isSaving = true;
        await this.updateVrma({
          dto: this.vendorrma, isAuthorize
        });
        this.isSaving = false;
        if (isExit) {
          this.navigateToList();
        } else {
          await this.getById(this.vendorRmaId);
        }
      } catch (e) {
        /*console.log(e.message);*/
        this.isSaving = false;
      }
    },
    async onAuthorize() {
      if (this.vendorrma.isAuthorized) {
        await this.saveVrmaDetails(false, !this.vendorrma.isAuthorized);
      } else {
        await this.$refs.headerDetails.getHeaderValidation();
        if (this.isValidHeader) {
          await this.saveVrmaDetails(false, !this.vendorrma.isAuthorized);
        }
      }
    },
    async onEmailRMA() {
        this.sendEmailData = {template: 'VRMA', source:'Vendor RMA',to:this.vendorrma.contactEmail,ReferenceId:this.vendorRmaId, reportSelectionOptions: this.reportOption}
        this.$root.$emit('bv::show::modal', 'send-email-modal');
      },
    navigateToList() {
      this.$router.push({name: 'vendorrmas'});
    },
    async onRefresh() {
      await this.getById(this.vendorRmaId);
    },
    async activateCreditMemo(){
      try {
        this.isSaving = true;
        // let vrmaObj = Object.assign({}, this.vendorrma);
        // vrmaObj.IsPending = 0;
        let vendorCredit = this.creditMemoByReference.find(x => x.id == this.selectedCreditMemo);
        if (vendorCredit) {
          let formData = {
            ...vendorCredit,
            id: this.selectedCreditMemo,
            IsPending: 0
          };
          await this.manageCreditMemo(formData);
        }
        
        this.isSaving = false;
      }catch (e) {
        this.isSaving = false;
      }
    },
    async createPO(){
      this.isCreatingPO = true;
      this.saveVrmaDetails(false, true)
      const response = await this.createPOByVendrRmaId(this.vendorrma.id);
      this.isCreatingPO = false;
      if (response != null && response.id > 0) {
        this.$router.push({
					name: 'purchaseorders.edit',
					params: { id: response.id },
				});
      }
    },
    openPickListModal(){
      console.log('i');
      this.$bvModal.show(this.pickListmodalId);
    }
  },
  async mounted() {
    this.setContainerLoader(true);
    await this.getById(this.vendorRmaId).then(async (res) => {
      this.setContainerLoader(false);
      if (this.vendorrma.purchaseOrderId) {
        await this.getPurchaseOrderLines(this.vendorrma.purchaseOrderId);
      }
    }).catch(() => {
      this.setContainerLoader(false);
      //return back to listing page because error in fetch record
      this.$router.push({name: 'vendorrmas'});
    });

  },
};
</script>